<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <!-- <v-card elevation="0"> -->
      <v-tabs class="mt-4 mb-10">
        <v-tab class="active">{{ $t("users") }}</v-tab>
        <!-- <v-tab :to="{ name: 'Roles' }">{{ $t("roles") }}</v-tab> -->
      </v-tabs>
      <div class="d-flex mb-4">
        <h2>{{ $t("users") }}</h2>
        <v-spacer></v-spacer>
        <!-- <template>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  v-bind="attrs"
                  height="40px"
                  width="150px"
                  v-on="on"
                  small
                >
                  {{ $t("farm.adduser") }}
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list class="user-menu" style="width: 152px">
                <v-list-item @click="addUser" style="padding: 0">
                  <v-list-item-avatar style="margin: 0px">
         
                    <v-img src="/img/add_user.svg"></v-img>

                  </v-list-item-avatar>

                  <v-list-item-title style="font-size: 14px">{{
                    $t("farm.adduser")
                  }}</v-list-item-title>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item @click="uploadUsers" style="padding: 0">
                  <v-list-item-avatar style="margin: 0px">
                    <v-img
                      style="background-size: unset"
                      src="/img/upload_user.svg"
                    ></v-img>
                  </v-list-item-avatar>
                  <v-list-item-title style="font-size: 14px">{{
                    $t("farm.uploadUsers")
                  }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template> -->
        <v-btn
          color="primary"
          dark
          height="40px"
          width="150px"
          small
          @click="addUser"
        >
          {{ $t("farm.adduser") }}
        </v-btn>
      </div>
      <!------------------------ Tablet screens ----------------------------->
      <!-- Start -->

      <!------------ End  ----------------->
      <v-card elevation="0" class="px-5 custom-comp" id="userlist">
        <v-card-text>
          <template>
            <v-tabs-items v-model="tab">
              <!-- <v-tab-item :value="2"><imported-users :key="importKey"/></v-tab-item> -->
              <v-tab-item @click="importKey + 1" :value="3"
                ><imported-files :key="importKey"
              /></v-tab-item>
            </v-tabs-items>
          </template>
          <div class="d-flex mt-5">
            <v-text-field
              prepend-inner-icon="mdi-magnify"
              outlined
              height="5px"
              :placeholder="$t('user.searchByEmailAndName')"
              dense
              v-model="search"
              @click:append="searchUsers"
              @input="resetSearchOnEmpty"
              class="shrink"
            ></v-text-field>
            <v-spacer></v-spacer>
            <div class="py-1 title">
              {{ from }} - {{ to }} of {{ totalUsers }}
            </div>
            <v-btn
              class="mx-2"
              fab
              small
              outlined
              color="primary"
              :disabled="tableOptions.page <= 1"
              @click="pageChange(false)"
            >
              <v-icon dark> mdi-chevron-left </v-icon>
            </v-btn>
            <v-btn
              class="mx-2"
              fab
              small
              outlined
              color="primary"
              :disabled="tableOptions.page >= totalPages"
              @click="pageChange(true)"
            >
              <v-icon dark> mdi-chevron-right </v-icon>
            </v-btn>
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-width="200"
              left
              :min-width="417"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark> mdi-cog-outline </v-icon>
                </v-btn>
              </template>

              <v-card width="450">
                <v-list>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>{{
                        $t("customization")
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <div class="pl-3 pt-2 font-weight-normal">
                    {{ $t("recordsPerPage") }}
                  </div>
                  <v-list-item>
                    <v-list-item-content>
                      <v-slider
                        v-model="itemsPerPageSlider"
                        :tick-labels="itemsPerPageOptions"
                        :max="3"
                        step="1"
                        ticks="always"
                        tick-size="4"
                      ></v-slider>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-n3"></v-divider>
                </v-list>
                <v-card-text>
                  <v-container fluid>
                    <v-row>
                      <v-col
                        class="mt-n9"
                        cols="6"
                        v-for="header in headers"
                        :key="header.value"
                      >
                        <v-checkbox
                          v-if="header.text !== ''"
                          v-model="selectedHeaders"
                          :label="header.text"
                          color="primary"
                          :value="header.value"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-layout justify-center>
                  <v-card-actions class="mb-5">
                    <v-spacer></v-spacer>

                    <v-btn
                      outlined
                      color="primary"
                      @click="menu = false"
                      width="fit-content"
                    >
                      {{ $t("restoreDefault") }}
                    </v-btn>
                    <v-btn
                      color="primary"
                      width="190"
                      @click="resetTableStructure"
                    >
                      {{ $t("apply") }}
                    </v-btn>
                  </v-card-actions>
                </v-layout>
              </v-card>
            </v-menu>
            <!-- <v-btn
                                  class="mx-2"
                                  fab
                                  small
                                  outlined
                                  color="primary"
                                  disabled
                              >
                                  <v-icon dark>
                                      mdi-cog-outline
                                  </v-icon>
                              </v-btn> -->
            <v-btn
              class="mx-2"
              fab
              small
              outlined
              color="primary"
              @click="exportToPDF"
            >
              <!-- <v-icon dark> mdi-export </v-icon> -->
              <v-img src="/icons/download.svg"></v-img>
            </v-btn>
            <v-btn
              class="mx-2"
              fab
              small
              outlined
              color="primary"
              @click="printPDF"
            >
              <v-icon dark> mdi-printer </v-icon>
            </v-btn>
          </div>
          <div ref="document">
            <v-data-table
              v-if="tab != 3"
              :headers="tableHeaders"
              :items="items"
              :items-per-page="10"
              v-model="selected"
              :loading="loading"
              :loading-text="$t('user.loadingUser')"
              :footer-props="{
                'items-per-page-options': [10, 25, 50],
                'show-first-last-page': true,
                'show-current-page': true,
                'items-per-page-text': 'Users per page',
              }"
              :options.sync="tableOptions"
              hide-default-footer
              :header-props="{
                'sort-icon': 'mdi-unfold-more-horizontal',
              }"
            >
              <template v-slot:top> </template>
              <template v-slot:progress>
                <v-progress-linear
                  color="primary"
                  :height="6"
                  indeterminate
                ></v-progress-linear>
              </template>
              <template v-slot:no-data v-if="items.length < 1">
                NO USER AVAILABLE
              </template>
              <!-- <template
                  v-if="items.length > 0"
                  v-slot:body="{ items, isSelected, select }"
                > -->
              <template v-if="items.length > 0" v-slot:body="{ items }">
                <tbody>
                  <tr
                    v-for="item in items"
                    :key="item.userNumber"
                    @mouseover="selectItem(item)"
                    @mouseleave="unSelectItem()"
                    style="position: relative; width: 0; height: 0"
                  >
                    <!-- <td>
                        <v-checkbox
                          :input-value="isSelected(item)"
                          @click="select(item, !isSelected(item))"
                          style="margin: 0px; padding: 0px"
                          hide-details
                        />
                      </td> -->
                    <template>
                      <td v-for="(h, index) in tableHeaders" :key="index">
                        <span v-if="h.value == 'id'">{{ `${item.id}` }}</span>
                        <span v-if="h.value == 'firstName'">{{
                          `${item.firstName} ${item.lastName}`
                        }}</span>
                        <span v-if="h.value == 'mobile'">{{
                          `${item[h.value] || ""}`
                        }}</span>
                        <span v-if="h.value == 'country'">{{
                          item?.country?.name
                        }}</span>
                        <span v-if="h.value == 'state'">{{
                          item?.state?.name
                        }}</span>
                        <span v-if="h.value == 'email'">{{
                          item[h.value]
                        }}</span>
                        <span v-if="h.value == 'role'" class="capitlize">{{
                          item[h.value]
                        }}</span>
                        <span v-if="h.value == 'registrationDate'">{{
                          item?.createdAt | formatDate
                        }}</span>

                        <span
                          v-if="h.value == 'department'"
                          class="capitlize"
                          >{{ item[h.value] }}</span
                        >
                        <span v-if="h.value == 'active'" class="capitlize"
                          ><v-btn
                            x-small
                            rounded
                            min-width="120"
                            :color="item.active == '1' ? 'green2' : 'red2'"
                            depressed
                            :class="
                              item.active == '1'
                                ? 'primary--text' + ' ' + 'border-active'
                                : 'red--text' + ' ' + 'border-deactivated'
                            "
                            height="34"
                          >
                            {{
                              item.active == 1
                                ? $t("active")
                                : $t("deactivated")
                            }}
                          </v-btn></span
                        >
                        <div class="d-flex" v-if="h.value == 'action'">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                x-small
                                fab
                                v-bind="attrs"
                                v-on="on"
                                @click="editUser(item)"
                                class="green-shadow"
                              >
                                <v-icon>mdi-pencil</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ $t("edit") }}</span>
                          </v-tooltip>
                          <v-tooltip bottom v-if="showStatusType == '1'">
                            <!-- eslint-disable -->
                            <template v-slot:activator="{ on, attrs }">
                              <!-- <v-btn
                                x-small
                                fab
                                v-bind="attrs"
                                v-on="on"
                                class="ml-1 green-shadow"
                                @click="changeUserStatus('0', item)"
                              >
                                <v-icon>mdi-trash-can</v-icon>
                              </v-btn> -->
                            </template>
                            <span>{{ $t("deactivate") }}</span>
                          </v-tooltip>
                          <v-tooltip bottom v-else>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                x-small
                                fab
                                v-bind="attrs"
                                v-on="on"
                                class="ml-1 green-shadow"
                                @click="changeUserStatus('1', item)"
                              >
                                <v-icon>mdi-play</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ $t("activate") }}</span>
                          </v-tooltip>
                        </div>
                      </td>
                      <!-- <td :key="index">{{ `#${item.userNumber}` }}</td>
                      <td :key="index">{{ item.email }}</td>
                      <td :key="index" class="capitlize">{{ item.role }}</td>
                      <td :key="index" class="capitlize">
                        {{ item.department }}
                      </td>
                      <td :key="index" class="capitlize text-center">
                        <v-btn
                          x-small
                          rounded
                          min-width="120"
                          :color="item.status == '1' ? 'green2' : 'red2'"
                          depressed
                          :class="
                            item.status == '1'
                              ? 'primary--text' + ' ' + 'border-active'
                              : 'red--text' + ' ' + 'border-deactivated'
                          "
                          height="34"
                        >
                          {{ item.status == 1 ? "Active" : "Deactivated" }}
                        </v-btn>
                      </td> -->
                    </template>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </div>
          <!-- </div> -->
        </v-card-text>
      </v-card>
      <!-- </v-card> -->
    </v-container>
    <add-user
      v-if="showAddUser"
      @userAdded="userAdded"
      @closeAddUser="showAddUser = false"
      :dialogI="showAddUser"
    ></add-user>
    <edit-user
      v-if="showEditUser"
      :user="editedUser"
      @userUpdated="userUpdated"
      @closeUpdateUser="editUserClosed"
      :dialogU="showEditUser"
    ></edit-user>
    <upload-users
      :dialogI="showUploadUser"
      @closeUploadUsers="closeUploadUsers"
    ></upload-users>
    <confirm-box
      :title="confirmElements.title"
      :message="confirmElements.message"
      :cancelBtnText="confirmElements.cancelBtnText"
      :confirmBtnText="confirmElements.confirmBtnText"
      :confirmData="confirmElements.confirmData"
      :dialog="confirm"
      @confirm:action="confirmDeactivate"
    ></confirm-box>
  </div>
</template>

<script>
/* eslint-disable */
import loadingMixin from "@/mixins/LoadingMixin";
import { UserPagination } from "@/graphql/Users.gql";
import AddUser from "@/views/user/AddUser";
import EditUser from "@/views/user/EditUser";
import UploadUsers from "@/views/user/UploadUsers";
import ImportedFiles from "@/views/user/ImportedFiles";
// import ImportedUsers from "@/views/user/ImportedUsers"
import ConfirmBox from "@/components/ConfirmBox";

import UserService from "@/_services/UserService";
import html2pdf from "html2pdf.js";
import printJS from "print-js";

export default {
  apollo: {
    UserPagination: {
      query: UserPagination,

      fetchPolicy: "network-only",
      update: (data) => data.UserPagination,
      variables() {
        return {
          ...this.tableOptions,
          page: this.tableOptions.page,
          limit: this.tableOptions.itemsPerPage,
          search: this.search,
        };
      },
      debounce: 1000,
      skip: false,
      result({ data }) {
        this.items = data.usersPagination?.rows;

        this.totalUsers = data.usersPagination?.totalCount;

        if (this.totalUsers < 1) {
          this.oldSelected = this.selectedHeaders;
          this.selectedHeaders = this.noRecordHeader;
        } else {
          if (this.oldSelected.length > 1)
            this.selectedHeaders = this.oldSelected;
          else {
            this.selectedHeaders = this.allSelectedHeaders;
            this.oldSelected = [];
          }
        }
        this.resetTableStructure();
        this.pageCount = Math.ceil(
          this.totalUsers / this.tableOptions.itemsPerPage
        );
        this.totalPages = Math.ceil(
          this.totalUsers / this.tableOptions.itemsPerPage
        );
        this.from =
          (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
        this.to =
          this.tableOptions.page * this.tableOptions.itemsPerPage -
          (this.tableOptions.itemsPerPage - this.items.length);
        this.loading = false;
      },
    },
  },
  async mounted() {
    this.loading = true;

    document.title = "Users";
    this.tableHeaders = this.headers;
    this.selectedHeaders = this.allSelectedHeaders;
  },
  updated() {
    // let element = document.getElementById("userlist").childNodes[0];
    // this.changeTableSortIcon(element);
  },

  created() {
    if (this.$vuetify.breakpoint.width <= 980) this.tabletGetUsers();
  },
  watch: {
    showEditUser: {
      handler(n, o) {
        console.log(n, "n");
        console.log(o, "o");
      },
    },
    tableOptions: {
      handler(nV) {
        console.log(JSON.stringify(nV, "table options"));
        this.getUserData();
      },
      deep: true,
    },
    tab: {
      handler(next, old) {
        if (next !== old) this.selected = [];
      },
    },
  },
  components: {
    "add-user": AddUser,
    "confirm-box": ConfirmBox,
    "edit-user": EditUser,
    "upload-users": UploadUsers,
    "imported-files": ImportedFiles,
    // 'imported-users': ImportedUsers,
  },
  computed: {},
  methods: {
    resetTableStructure() {
      this.loading = true;
      this.startLoading();

      this.tableHeaders = this.headers.filter((header) =>
        this.selectedHeaders.includes(header.value)
      );
      this.tableOptions.itemsPerPage =
        this.itemsPerPageOptions[this.itemsPerPageSlider];
      this.menu = false;
      this.stopLoading();
    },
    async exportToPDF() {
      html2pdf(this.$refs.document, {
        margin: 0.1,
        filename: "UserList.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          orientation: "landscape",
          compress: false,
        },
      });
    },

    async printPDF() {
      let opt = {
        margin: 1,
        filename: "UserList.pdf",
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
      };

      let worker = await html2pdf()
        .set(opt)
        .from(this.$refs.document)
        .toCanvas()
        .outputPdf("blob", "UserList.pdf");
      let file = new File([worker], "userList.pdf", {
        type: "application/pdf",
      });
      console.log(file);
      var pdfUrl = await URL.createObjectURL(file);
      console.log(pdfUrl);
      await printJS({ printable: `${pdfUrl}`, type: "pdf", showModal: true });
    },
    addUser() {
      this.showAddUser = true;
    },
    uploadUsers() {
      this.showUploadUser = true;
    },
    async userAdded(res) {
      if (res.success) {
        this.$notify({
          title: this.$t("user.userAdded"),
          text: res.message,
          type: "success",
          duration: 10000,
        });
        await this.$apollo.queries.UserPagination.refetch();
      } else {
        this.$notify({
          title: this.$t("user.userNotAdded"),
          text: res.message.message.replace("GraphQL error:", ""),
          type: "error",
          duration: 10000,
        });
      }
    },
    async userUpdated(res) {
      if (res.success) {
        this.$notify({
          title: this.$t("user.userUpdated"),
          text: res.message,
          type: "success",
        });
        await this.$apollo.queries.UserPagination.refetch();
      } else {
        this.$notify({
          title: this.$t("user.userNotUpdated"),
          text: res.message,
          type: "error",
        });
      }
    },
    selectItem(item) {
      this.selectedItem = item;
    },
    unSelectItem() {
      this.selectedItem = false;
    },

    tabletGetUsers() {
      this.loading = true;
      UserService.getUsers(
        this.tabletTableOptions,
        this.showStatusType,
        this.search,
        this.imported
      )
        .then((res) => {
          if (res.success) {
            this.items = res.data.rows;
            this.totalUsers = res.data.totalRows;
            this.activeUsers = res.data.activeUsers;
            this.deactiveUsers = res.data.deactiveUsers;
            this.importedUsers = res.data.importedUsers;
            this.showingRows = res.data.numRows;
            this.pageCount = Math.ceil(
              this.totalUsers / this.tabletTableOptions.itemsPerPage
            );
            this.totalPages = Math.ceil(
              this.totalUsers / this.tabletTableOptions.itemsPerPage
            );
            this.from =
              (this.tabletTableOptions.page - 1) *
                this.tabletTableOptions.itemsPerPage +
              1;
            this.to =
              this.tabletTableOptions.page *
                this.tabletTableOptions.itemsPerPage -
              (this.tabletTableOptions.itemsPerPage - res.data.numRows);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.items = [];
          console.log(err);
          // if(err.response.status == 403)
          // this.$router.go(-1)
        });
    },

    changeUserStatusType(type) {
      if (this.showStatusType == type) return;
      this.showStatusType = type;

      if (type == "importedfiles") {
        this.items = [];
        return;
      }
      if (type == "imported") this.imported = 1;
      else this.imported = 0;
    },
    async searchUsers() {
      if (this.search == "") return;
      if (this.$vuetify.breakpoint.width <= 980) {
        this.tabletTableOptions.page = 1;
        this.tabletGetUsers();
      } else {
        this.tableOptions.page = 1;
        await this.$apollo.queries.UserPagination.refetch();
      }
    },
    async resetSearchOnEmpty() {
      // if (this.search === "") return;
      if (this.$vuetify.breakpoint.width <= 980) {
        this.tabletTableOptions.page = 1;
        this.tabletGetUsers();
      } else {
        this.tableOptions.page = 1;
        await this.$apollo.queries.UserPagination.refetch();
      }
    },

    async getUserData() {
      this.loading = true;
      await this.$apollo.queries.UserPagination.refetch();
      // this.loading = false
      // console.log(sortBy, sortDesc) // shortBy = email, sortDesc true/false
    },

    editUser(user) {
      this.editedUser = user;
      console.log(this.editedUser);
      this.showEditUser = true;
    },

    changeUserStatus(status, user) {
      this.confirmElements.title =
        status == "1"
          ? this.$t("user.activateUser")
          : this.$t("user.deactivateUser");
      this.confirmElements.confirmBtnText =
        status == "1" ? this.$t("activate") : this.$t("deactivate");
      this.confirmElements.confirmData = { user: user, status: status };
      this.confirm = true;
    },

    confirmDeactivate(action, confirmData) {
      if (action) {
        this.startLoading();
        UserService.updateStatus({
          userNumber: confirmData.user.userNumber,
          status: confirmData.status,
        })
          .then(async (res) => {
            if (res.success) {
              await this.$apollo.queries.UserPagination.refetch();
              this.stopLoading();
              this.confirm = false;
              this.$notify({
                title:
                  confirmData.status == "active"
                    ? "User Activated"
                    : "User Deactivated",
                text: res.message,
                type: "success",
              });
            } else {
              this.stopLoading();
              this.confirm = false;
              this.$notify({
                title: "Unable to update",
                text: res.message,
                type: "error",
              });
            }
          })
          .catch((err) => {
            console.log(err);
            this.stopLoading();
            this.confirm = false;
          });
      } else {
        this.confirm = false;
      }
    },

    async editUserClosed() {
      this.resetEditedUser();
      await this.$apollo.queries.UserPagination.refetch();
      if (this.showEditUser) {
        this.showEditUser = false;
        console.log(this.showEditUser);
      }
    },

    resetEditedUser() {
      this.editedUser = {
        name: "",
        email: "",
        mobile: "",
        password: "",
        department: "administrator",
        role: "manager",
      };
    },
    pageChange(t) {
      if (t) {
        this.tableOptions.page = this.tableOptions.page + 1;
        console.log(this.tableOptions.page, "this.tableOptions.page");
      } else {
        this.tableOptions.page = this.tableOptions.page - 1;
      }
      this.getUserData();
    },
    tabletPageChange(t) {
      if (t) {
        this.tabletTableOptions.page = this.tabletTableOptions.page + 1;
        console.log(
          this.tabletTableOptions.page,
          "this.tabletTableOptions.page"
        );
      } else {
        this.tabletTableOptions.page = this.tabletTableOptions.page - 1;
      }
      this.tabletGetUsers();
    },
    closeUploadUsers(success) {
      this.showUploadUser = false;
      if (success === true) {
        this.tab = 3;
        this.importKey = this.importKey + 1;
      }
    },
    // changeTableSortIcon(element) {
    //   let allTh =
    //     element?.childNodes[2]?.childNodes[1]?.childNodes[0]?.childNodes[1]
    //       ?.childNodes[0]?.childNodes;
    //   let index = 0;
    //   for (let el of allTh) {
    //     if (index > 0 && el.childNodes[1])
    //       el.childNodes[1].className =
    //         "v-icon notranslate v-data-table-header__icon mdi mdi-unfold-more-horizontal theme--light";
    //     index++;
    //   }
    // },
  },
  data() {
    return {
      userPaginationObj: {},
      imported: 0,
      importKey: 1,
      tab: 0,
      from: 0,
      to: 0,
      menu: false,
      itemsPerPageSlider: 1,
      itemsPerPageOptions: [5, 10, 25, 50],
      selectedHeaders: [],
      tableHeaders: [],
      oldSelected: [],
      totalPages: 1,
      showingRows: 0,
      pageCount: 0,
      transition: true,
      activeUsers: 0,
      deactiveUsers: 0,
      totalUsers: 0,
      importedUsers: 0,
      confirm: false,
      confirmElements: {
        title: this.$t("deactivateUser"),
        message: this.$t("user.userStatusMsg"),
        confirmBtnText: this.$t("deactivate"),
        cancelBtnText: this.$t("cancel"),
        confirmData: {},
      },
      tableOptions: {},
      tabletTableOptions: { itemsPerPage: 10, page: 1, sortBy: [] },
      showStatusType: "1",
      search: "",
      selected: [],
      items: [],
      selectedItem: false,
      loading: false,
      loadingText: this.$t("loadingPleaseWait"),
      showAddUser: false,
      showEditUser: false,
      showUploadUser: false,
      editedUser: {
        name: "",
        email: "",
        mobile: "",
        password: "",
        department: this.$t("administrator"),
        role: this.$t("manager"),
      },
      // actions: [
      //     { name: 'Add a User', method: 'addUser' },
      //     { name: 'Import Users', method: 'importUser' },
      // ],
      breadcrumbs: [
        {
          text: this.$t("dashboard"),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t("users"),
          disabled: true,
          to: "breadcrumbs_link_1",
        },
      ],
      allSelectedHeaders: [
        "id",
        "firstName",
        "email",
        "mobile",
        "country",
        "state",
        "role",
        "registrationDate",
        "active",
        "action",
      ],
      noRecordHeader: ["firstName", "email", "mobile", "role", "active"],
      headers: [
        {
          text: "ID",
          align: "start",
          sortable: true,
          value: "id",
          class: "black--text",
        },
        {
          text: this.$t("User Name"),
          align: "start",
          sortable: true,
          value: "firstName",
          class: "black--text",
        },
        // {
        //   text: this.$t("user.userID"),
        //   align: "start",
        //   sortable: true,
        //   value: "userNumber",
        //   class: "black--text",
        // },
        {
          text: this.$t("Email"),
          value: "email",
          class: "black--text",
        },
        {
          text: this.$t("Phone") + "#",
          value: "mobile",
          class: "black--text",
        },
        {
          text: "Country",
          value: "country",
          class: "black--text",
        },
        {
          text: "Provice State",
          value: "state",
          class: "black--text",
        },
        {
          text: this.$t("Role"),
          value: "role",
          sortable: true,
          class: "black--text",
        },
        {
          text: this.$t("Reg. Date"),
          value: "registrationDate",
          sortable: true,
          class: "black--text",
        },
        {
          text: this.$t("Status"),
          value: "active",
          sortable: true,
          class: "black--text",
        },
        {
          text: "",
          value: "action",
          align: "center",
          sortable: false,
          class: "black--text",
        },
      ],
    };
  },
  mixins: [loadingMixin],
};
</script>

<style lang="scss" scoped>
::v-deep .v-image__image--cover {
  background-size: unset !important;
}
::v-deep .v-tab:hover {
  background-color: #caf1e2;
  color: $primary_color !important;
}
::v-deep .v-data-table-header {
  background: $secondary2-color;
}
::v-deep .v-data-table-header span {
  // text-transform: uppercase !important;
  color: black;
}

::v-deep .v-data-table-header th {
  white-space: nowrap;
}
::v-deep .v-data-table-header__icon {
  display: inline-block;
  opacity: 100 !important;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.border-active {
  border: 1px solid green !important;
}

.border-deactivated {
  border: 1px solid red !important;
}
::v-deep .green-shadow:hover {
  background-color: $primary_color;
  color: white;
}

.user-menu {
  border: 2px solid $primary_color !important;
}

.active {
  color: $primary_color !important;
  border-bottom: 2px solid $primary_color;
}
::v-deep .v-tabs-slider-wrapper .v-tabs-slider {
  background-color: transparent !important;
  border-radius: 5px !important;
}

.v-tab {
  text-transform: none !important;
}
</style>
